/* eslint-disable */
import React, { FC, useState } from 'react'
import { SolveFeedbackModalProps } from './types'
import ModalTemplate from 'uiKit/ModalTemplate'
import { SparklesIcon } from 'uiKit/icons/SparklesIcon'
import * as LocalStyles from './styles'
import styles from './styles.module.scss'
import { useModalToggle } from 'tabs/nlp/components/unansweredQuestions/hooks'
import { QuestionAnswerSection } from './QuestionAnswerSection'
import { useUserFeedback } from '../../context'
import * as ModalStyles from '../../../ModalWindow/modal.styles'
import { TrainButtonState } from '../../../unansweredQuestions/util/button'
import { KnowledgeSubQuestionElement } from './QuestionAnswerSection/sub_question/knowledge/knowledge-sub-question-element'
import { SubQuestion } from '../../types'
import { DatasetSubQuestionElement } from './QuestionAnswerSection/sub_question/dataset/dataset-sub-question-element'
import { UnknownQuestionCreateAPI } from '../../../../api/types'
import { ModalButton } from '../../../unansweredQuestions/styles'
import { alertSuccess } from 'api'
import { NoSubQuestionView } from './QuestionAnswerSection/sub_question/no-sub-question-view'
import { TrainedQuestion } from './QuestionAnswerSection/types'
import { userFeedbackService } from '../../api/userFeedback'

export const SolveFeedbackModal: FC<SolveFeedbackModalProps> = ({ feedback }) => {
  const { creteNewQuestion, setUserFeedbackRecords } = useUserFeedback()
  const { toggleModal, isOpen } = useModalToggle()
  const [solved, setSolved] = useState<boolean>(feedback.solved)

  const createNewQuestionCallback = async (question: Partial<UnknownQuestionCreateAPI>) => {
    return creteNewQuestion(feedback.id, question)
  }

  const getSubQuestion = (subQuestion: SubQuestion, index: number, feedbackId: string) => {
    const SubQuestionComponent = subQuestionComponents[subQuestion.type]
    if (!SubQuestionComponent) {
      return 'unknown subquestion type'
    }

    return (
      <SubQuestionComponent
        key={index}
        index={index + 1}
        subQuestion={subQuestion}
        createNewQuestionCallback={createNewQuestionCallback}
        feedbackId={feedbackId}
        setSolvedCallback={setSolved}
        modifyQuestions={modifySubQuestions}
      />
    )
  }

  const modifySubQuestions = (questions: TrainedQuestion[], subQuestionId: string) => {
    setUserFeedbackRecords(prevState =>
      prevState.map(feedbackItem => {
        if (feedbackItem.id !== feedback.id) return feedbackItem
        return {
          ...feedbackItem,
          subQuestions: feedbackItem.subQuestions.map(subQuestion =>
            subQuestion.subQuestionId === subQuestionId ? { ...subQuestion, trainedQuestions: questions } : subQuestion,
          ),
        }
      }),
    )
  }

  const modifyFeedbackTrainedQuestions = (questions: TrainedQuestion[]) => {
    setUserFeedbackRecords(prevState =>
      prevState.map(feedbackItem => {
        if (feedbackItem.id !== feedback.id) return feedbackItem
        return {
          ...feedbackItem,
          trainedQuestions: questions,
        }
      }),
    )
  }

  return (
    <>
      <LocalStyles.SolveButton onClick={toggleModal} state={solved ? TrainButtonState.SOLVED : TrainButtonState.ACTIVE}>
        {solved ? 'Solved' : 'Solve'}
      </LocalStyles.SolveButton>
      <ModalTemplate
        containerClasses={styles.modal}
        open={isOpen}
        title="User Feedback Details"
        titleIcon={
          <ModalStyles.TitleIconWrapper>
            <SparklesIcon />
          </ModalStyles.TitleIconWrapper>
        }
        onClose={toggleModal}
        withFooter={false}>
        <ModalStyles.ModalContainer>
          {feedback.feedbackContent && (
            <ModalStyles.UserFeedbackContainer>
              <ModalStyles.UserFeedbackIcon>User Feedback : </ModalStyles.UserFeedbackIcon>
              <span>{feedback.feedbackContent}</span>
            </ModalStyles.UserFeedbackContainer>
          )}
          {feedback.subQuestions?.length ? (
            <QuestionAnswerSection
              question={feedback.userMessage}
              answer={feedback.botMessage}
              questionTitle="User Question"
              answerTitle="Bot Answer"
            />
          ) : (
            <NoSubQuestionView
              question={feedback.userMessage}
              answer={feedback.botMessage}
              trainingQuestions={feedback.trainedQuestions}
              feedbackId={feedback.id}
              createNewQuestionCallback={createNewQuestionCallback}
              setSolvedCallback={setSolved}
              modifyQuestions={modifyFeedbackTrainedQuestions}></NoSubQuestionView>
          )}

          <div
            style={{
              background: 'var(--color-selago-grey)',
              margin: '0 -1rem',
              padding: '0 1rem 1rem',
              borderRadius: '10px',
            }}>
            {feedback.subQuestions.map((subQuestion, index) => getSubQuestion(subQuestion, index, feedback.id))}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: 'auto',
            }}>
            <ModalButton
              onClick={() => {
                setSolved(true)
                userFeedbackService.markAsSolved(feedback.id, false)
                alertSuccess('Feedback is solved')
              }}
              state={!solved ? TrainButtonState.ACTIVE : TrainButtonState.INACTIVE}>
              Mark as solved
            </ModalButton>
          </div>
        </ModalStyles.ModalContainer>
      </ModalTemplate>
    </>
  )
}

export const subQuestionComponents = {
  knowledge: KnowledgeSubQuestionElement,
  dataset: DatasetSubQuestionElement,
} as const
